import React from 'react';
import Spinner from 'components/loader/Spinner';
import { HomePageProps } from 'types/Filters';
import Pagination from 'components/pager/Pagination';
import HomeCard from './HomeCard';
import { useRecentlyViewed } from './recentlyViewed/RecentlyViewedProvider';
import SortingDropDown from './Components/SortingDropDowns';
import { useModal } from 'hooks/useModal';
import { NCardSlim } from '@innersource-nn/novoui-react';

export default function WelcomeView({
    items,
    error,
    loading,
    filter,
    setFilter,
}: HomePageProps) {
    const { recentlyViewedDatasets, loadingRecents } = useRecentlyViewed();
    const { openNewDatasetModal, openDatasetAccess } = useModal();

    const cardContent = [
        {
            title: 'Request access to dataset',
            subtitle: 'Search and request access',
            onClick: () => openDatasetAccess({ count: items.count }),
        },
        {
            title: 'Create Dataset',
            subtitle: 'Upload or import your data',
            onClick: () => openNewDatasetModal({}),
        },
    ];

    return (
        <div>
            <div className="mb-24">
                <b className="section-title">Quick Start</b>
                <div className="dataset-grid mb-16 gap-y-8">
                    {cardContent.map((item, index) => (
                        <NCardSlim
                            headline={item.title}
                            subheader={item.subtitle}
                            onClick={item.onClick}
                            key={`card-${index}`}
                            trailingIcon={
                                loading && index === 0
                                    ? undefined
                                    : 'chevronRight'
                            }
                            disabled={loading && index === 0}
                        />
                    ))}
                </div>
            </div>
            {recentlyViewedDatasets.length > 0 && (
                <div>
                    <b className="section-title">Latest viewed</b>
                    {loadingRecents ? (
                        <Spinner />
                    ) : (
                        <div className="dataset-grid gap-y-14 h-[16rem] overflow-hidden">
                            {recentlyViewedDatasets.map((item, index) => (
                                <div
                                    key={index}
                                    className="home-page-grid-card-div  "
                                >
                                    <HomeCard {...item} />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
            <div>
                <div className="flex justify-between items-end">
                    <b className="section-title">All Datasets</b>
                    <SortingDropDown setFilter={setFilter} />
                </div>
                {loading ? (
                    <Spinner />
                ) : (
                    !error && (
                        <div className="dataset-grid gap-y-16 mb-64">
                            {items.nodes.map((item, index) => (
                                <div
                                    key={index}
                                    className="home-page-grid-card-div  "
                                >
                                    <HomeCard {...item} />
                                </div>
                            ))}
                        </div>
                    )
                )}
            </div>
            {!loading && items.count > 0 && (
                <Pagination
                    items={items}
                    filter={filter}
                    setFilter={setFilter}
                />
            )}
        </div>
    );
}
